import { ConditionIcons } from 'components';
import DataGridDisplay from 'components/DataGridDisplay/DataGridDisplay';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { FaEye, FaHome, FaWind } from 'react-icons/fa';
import { FaDroplet, FaTemperatureHalf } from 'react-icons/fa6';
import { PiWind } from 'react-icons/pi';
import { WiSprinkle } from 'react-icons/wi';

export default function WeatherInfoDisplay({ data, title }) {
  return (
    <div className="d-flex flex-grow-1">
      <DataGridDisplay
        title={title}
        icon={<ConditionIcons conditionId={parseInt(data?.icon || '0')} size={25} />}
      >
        <Container className="justify-content-evenly my-1">
          <Row>
            <Col sm={12} md={4} className="d-flex flex-row">
              <FaTemperatureHalf size={21} className="me-2" />
              <div>{`Temperature: ${data.temperature}°F`}</div>
            </Col>

            <Col sm={12} md={4} className="d-flex flex-row">
              <FaDroplet size={21} className="me-2" />
              <div>{`Humidity: ${data.humidity}%`}</div>
            </Col>

            <Col sm={12} md={4} className="d-flex flex-row">
              <FaHome size={21} className="me-2" />
              <div>{`Comfort Level: ${data.comfort}°F`}</div>
            </Col>
          </Row>

          <Row>
            <Col sm={12} md={4} className="d-flex flex-row">
              <FaEye size={21} className="me-2" />
              <div>{`Visibility: ${data.visibility} mi`}</div>
            </Col>

            <Col sm={12} md={4} className="d-flex flex-row">
              <FaWind size={21} className="me-2" />
              <div>{`Wind: ${data.wind_speed} MPH`}</div>
            </Col>

            <Col sm={12} md={4} className="d-flex flex-row">
              <PiWind size={21} className="me-2" />
              <div>{`Wind Direction: ${data.wind_short}`}</div>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={4} className="d-flex flex-row">
              <WiSprinkle size={21} className="me-2" />
              <div>{`Dew Point: ${data.dew_point}°F`}</div>
            </Col>
          </Row>
        </Container>
      </DataGridDisplay>
    </div>
  );
}
